<template>
    <div>
        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <!-- Pay modal -->
        <b-modal size="lg" ref="payout-modal" id="payout-modal" centered title="Request payout">
            <!-- Error management -->
            <CustomAlerts :errors="modalerrors"></CustomAlerts>

            <p>
                Fill out the form below and we'll get to processing your payment within the next
                couple of days!
            </p>

            <form method="POST" v-on:submit.prevent="requestPayout">
                <!-- Email input -->
                <b-form-group label-cols="4" label-cols-lg="2" label="PayPay email">
                    <b-form-input
                        id="email"
                        type="email"
                        v-model="form.email"
                        placeholder="Enter your PayPal email here"
                    ></b-form-input>
                </b-form-group>

                <!-- Amount input -->
                <b-form-group label-cols="4" label-cols-lg="2" label="Amount">
                    <b-form-input
                        id="amount"
                        type="number"
                        v-model="form.amount"
                        placeholder="Enter your requested payout amount"
                        style="width: inherit"
                    ></b-form-input>
                </b-form-group>

                <input
                    type="submit"
                    class="d-none"
                    @click="requestPayout"
                    :disabled="modalIsLoading"
                />
            </form>

            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-button
                    type="submit"
                    variant="success"
                    :disabled="modalIsLoading"
                    @click="requestPayout"
                >
                    Request payout
                </b-button>
                <!-- Button with custom close trigger value -->
                <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
            </template>
        </b-modal>

        <!-- Start display -->
        <div v-if="displayPage">
            <!-- <b-alert show variant="warning gutter-b"
                ><strong>Warning:</strong> Please note that all outstanding earnings for 2020 will
                be automatically cashed out at the end of the year. Payouts will be temporarily
                de-activated for maintenance the first week of January. We apologise for any
                inconvenience.</b-alert
            > -->
            <!-- Start title card -->
            <div class="card card-custom gutter-b">
                <div class="card-header">
                    <div class="card-title">
                        <span class="card-icon">
                            <i class="fas fa-dollar-sign text-primary"></i>
                        </span>
                        <h3 class="card-label">Affiliate Program</h3>
                    </div>
                </div>
                <div class="card-body">
                    <p>
                        Hashtastic features an affiliate program, and you can start earning money
                        for every sale you send our way! Simply use the following URL for people to
                        sign up and watch your account balance grow as your visitors become
                        customers.
                    </p>
                    <p>
                        For each sale you generate, you earn 20%. Not just on the initial sale, but
                        on every sale after that!
                    </p>

                    <!-- Links -->
                    <!-- Home -->
                    <blockquote class="blockquote btn-group w-100">
                        <a class="copy-link">
                            <i class="fas fa-copy mr-5 mt-1 blockquote-icon" id="tooltip-1"></i>
                        </a>
                        <p style="position: absolute; left: -999em">
                            {{ affiliatesAll.links.home }}
                        </p>
                        <b-tooltip target="tooltip-1" triggers="hover"> Copy link </b-tooltip>
                        <p class="mb-0">
                            {{ affiliatesAll.links.home }}
                        </p>
                    </blockquote>
                    <!-- Seperator -->
                    <div class="separator separator-dashed mb-4"></div>

                    <!-- Register -->
                    <blockquote class="blockquote btn-group w-100">
                        <a class="copy-link">
                            <i class="fas fa-copy mr-5 mt-1 blockquote-icon" id="tooltip-2"></i>
                        </a>
                        <p style="position: absolute; left: -999em">
                            {{ affiliatesAll.links.register }}
                        </p>
                        <b-tooltip target="tooltip-2" triggers="hover"> Copy link </b-tooltip>
                        <p class="mb-0">
                            {{ affiliatesAll.links.register }}
                        </p>
                    </blockquote>
                    <!-- Seperator -->
                    <div class="separator separator-dashed mb-4"></div>

                    <!-- APP -->
                    <blockquote class="blockquote btn-group w-100">
                        <a class="copy-link">
                            <i class="fas fa-copy mr-5 mt-1 blockquote-icon" id="tooltip-3"></i>
                        </a>
                        <p style="position: absolute; left: -999em">
                            {{ affiliatesAll.links.app_register }}
                        </p>
                        <b-tooltip target="tooltip-3" triggers="hover"> Copy link </b-tooltip>
                        <p class="mb-0">
                            {{ affiliatesAll.links.app_register }}
                        </p>
                    </blockquote>
                </div>
            </div>
            <!-- End title card -->

            <div class="row">
                <!-- Sales column -->
                <div class="col-xl-6">
                    <div class="card card-custom gutter-b">
                        <div class="card-header border-0">
                            <div class="card-title">
                                <h3 class="card-label">Sales</h3>
                            </div>
                        </div>
                        <div class="card-body pt-0">
                            <div class="pt-3">
                                <!--begin::Item-->
                                <div
                                    class="d-flex align-items-center mb-1 bg-hover-light p-4 mt-1 rounded p-1"
                                >
                                    <!--begin::Icon-->
                                    <span class="svg-icon svg-icon-warning mr-5">
                                        <span class="svg-icon svg-icon-lg col-1">
                                            <i class="fas fa-2x fa-user text-primary"></i>
                                        </span>
                                    </span>
                                    <!--end::Icon-->
                                    <!--begin::Title-->
                                    <div class="d-flex flex-column flex-grow-1 mr-2">
                                        <a
                                            class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                            >Sign-ups</a
                                        >
                                        <span class="text-muted font-weight-bold">
                                            Total number of users signing up with your affiliate
                                            link
                                        </span>
                                    </div>
                                    <!--end::Title-->
                                    <!--begin::Lable-->
                                    <span class="font-weight-bolder py-1 font-size-lg text-primary">
                                        {{
                                            addCommaToNumber(affiliatesAll.metrics._global.signups)
                                        }}
                                    </span>
                                    <!--end::Lable-->
                                </div>
                                <!--end::Item-->
                                <!--begin::Item-->
                                <div
                                    class="d-flex align-items-center mb-1 bg-hover-light p-4 mt-1 rounded p-1"
                                >
                                    <!--begin::Icon-->
                                    <span class="svg-icon svg-icon-warning mr-5 col-1">
                                        <span class="svg-icon svg-icon-lg">
                                            <i
                                                class="fas fa-2x fa-cart-arrow-down text-primary"
                                            ></i>
                                        </span>
                                    </span>
                                    <!--end::Icon-->
                                    <!--begin::Title-->
                                    <div class="d-flex flex-column flex-grow-1 mr-2">
                                        <a
                                            class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                            >Sales</a
                                        >
                                        <span class="text-muted font-weight-bold">
                                            Total number of sales from users signing up with your
                                            affiliate link
                                        </span>
                                    </div>
                                    <!--end::Title-->
                                    <!--begin::Lable-->
                                    <span class="font-weight-bolder py-1 font-size-lg text-primary">
                                        {{
                                            addCommaToNumber(
                                                affiliatesAll.metrics._global.payments_count
                                            )
                                        }}
                                    </span>
                                    <!--end::Lable-->
                                </div>
                                <!--end::Item-->
                                <!--begin::Item-->
                                <div
                                    class="d-flex align-items-center mb-1 bg-hover-light p-4 mt-1 rounded p-1"
                                >
                                    <!--begin::Icon-->
                                    <span class="svg-icon svg-icon-warning mr-5 col-1">
                                        <span class="svg-icon svg-icon-lg">
                                            <i class="fas fa-2x fa-percentage text-primary"></i>
                                        </span>
                                    </span>
                                    <!--end::Icon-->
                                    <!--begin::Title-->
                                    <div class="d-flex flex-column flex-grow-1 mr-2">
                                        <a
                                            class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                            >Effectiveness</a
                                        >
                                        <span class="text-muted font-weight-bold">
                                            Number of users paying for subscription after signing-up
                                        </span>
                                    </div>
                                    <!--end::Title-->
                                    <!--begin::Lable-->
                                    <span class="font-weight-bolder py-1 font-size-lg text-primary">
                                        {{
                                            roundTwoDecimals(
                                                affiliatesAll.metrics._global.effectiveness
                                            )
                                        }}%
                                    </span>
                                    <!--end::Lable-->
                                </div>
                                <!--end::Item-->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End sales column -->

                <!-- Start earnings column -->
                <div class="col-xl-6">
                    <template v-if="affiliatesAll.pre2021">
                        <b-button-group class="gutter-b w-100">
                            <b-button
                                @click="switchCurrency('usd')"
                                :active="this.currencyTab == 'usd'"
                                >Before 2021</b-button
                            >
                            <b-button
                                variant="primary"
                                @click="switchCurrency('eur')"
                                :active="this.currencyTab == 'eur'"
                                >2021 onwards</b-button
                            >
                        </b-button-group>
                    </template>
                    <div class="card card-custom gutter-b">
                        <div class="card-header border-0">
                            <div class="card-title">
                                <h3 class="card-label">Earnings</h3>
                            </div>
                        </div>
                        <div class="card-body pt-0">
                            <div class="pt-3">
                                <!--begin::Item-->
                                <div
                                    class="d-flex align-items-center mb-1 bg-hover-light p-4 mt-1 rounded p-1"
                                >
                                    <!--begin::Icon-->
                                    <span class="svg-icon svg-icon-warning mr-5 col-1">
                                        <span class="svg-icon svg-icon-lg">
                                            <i class="fas fa-2x fa-wallet text-success"></i>
                                        </span>
                                    </span>
                                    <!--end::Icon-->
                                    <!--begin::Title-->
                                    <div class="d-flex flex-column flex-grow-1 mr-2">
                                        <a
                                            class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                            >Balance</a
                                        >
                                        <span class="text-muted font-weight-bold">
                                            Outstanding balance to be paid
                                        </span>
                                    </div>
                                    <!--end::Title-->
                                    <!--begin::Lable-->
                                    <span class="font-weight-bolder py-1 font-size-lg text-success">
                                        <template v-if="currencyTab == 'eur'">
                                            {{ roundTwoDecimals(affiliates.balance) }} €
                                        </template>
                                        <template v-else>
                                            $
                                            {{ roundTwoDecimals(affiliates.balance) }}
                                        </template>
                                    </span>
                                    <!--end::Lable-->
                                </div>
                                <!--end::Item-->
                                <!--begin::Item-->
                                <div
                                    class="d-flex align-items-center mb-1 bg-hover-light p-4 mt-1 rounded p-1"
                                >
                                    <!--begin::Icon-->
                                    <span class="svg-icon svg-icon-warning mr-5 col-1">
                                        <span class="svg-icon svg-icon-lg">
                                            <i class="fas fa-2x fa-receipt text-primary"></i>
                                        </span>
                                    </span>
                                    <!--end::Icon-->
                                    <!--begin::Title-->
                                    <div class="d-flex flex-column flex-grow-1 mr-2">
                                        <a
                                            class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                            >Paid out</a
                                        >
                                        <span class="text-muted font-weight-bold">
                                            Earnings paid out so far
                                        </span>
                                    </div>
                                    <!--end::Title-->
                                    <!--begin::Lable-->
                                    <span class="font-weight-bolder py-1 font-size-lg text-primary">
                                        <template v-if="currencyTab == 'eur'">
                                            {{ addCommaToNumber(affiliates.payouts_total) }} €
                                        </template>
                                        <template v-else>
                                            $
                                            {{ addCommaToNumber(affiliates.payouts_total) }}
                                        </template>
                                    </span>
                                    <!--end::Lable-->
                                </div>
                                <!--end::Item-->
                                <!--begin::Item-->
                                <div
                                    class="d-flex align-items-center mb-1 bg-hover-light p-4 mt-1 rounded p-1"
                                >
                                    <!--begin::Icon-->
                                    <span class="svg-icon svg-icon-warning mr-5 col-1">
                                        <span class="svg-icon svg-icon-lg">
                                            <i class="fas fa-2x fa-dollar-sign text-primary"></i>
                                        </span>
                                    </span>
                                    <!--end::Icon-->
                                    <!--begin::Title-->
                                    <div class="d-flex flex-column flex-grow-1 mr-2">
                                        <a
                                            class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                            >Total Earnings</a
                                        >
                                        <span class="text-muted font-weight-bold">
                                            Total earned through the affiliate program
                                        </span>
                                    </div>
                                    <!--end::Title-->
                                    <!--begin::Lable-->
                                    <span class="font-weight-bolder py-1 font-size-lg text-primary">
                                        <template v-if="currencyTab == 'eur'">
                                            {{ roundTwoDecimals(affiliates.total_earnings) }} €
                                        </template>
                                        <template v-else>
                                            $
                                            {{ roundTwoDecimals(affiliates.total_earnings) }}
                                        </template>
                                    </span>
                                    <!--end::Lable-->
                                </div>
                                <!--end::Item-->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End earnings column -->

                <div class="col-xl-6">
                    <div
                        class="card card-custom gutter-b bg-success text-white"
                        style="height: 150px"
                    >
                        <!--begin::Body-->
                        <div
                            class="card-body d-flex align-items-center justify-content-between flex-wrap"
                        >
                            <div class="mr-2">
                                <h3 class="display-4">
                                    <template v-if="currencyTab == 'eur'">
                                        {{ roundTwoDecimals(affiliates.total_earnings) }} €
                                    </template>
                                    <template v-else>
                                        $
                                        {{ roundTwoDecimals(affiliates.total_earnings) }}
                                    </template>
                                </h3>
                                <div class="font-size-lg mt-2">
                                    Earnings since joining Hashtastic
                                </div>
                            </div>
                            <a
                                @click="openPayoutModal"
                                class="btn btn-white font-weight-bold py-3 px-6"
                                >Request payout</a
                            >
                        </div>
                        <!--end::Body-->
                    </div>

                    <template v-if="currencyTab == 'usd'">
                        <b-alert show variant="warning gutter-b"
                            ><strong>Info:</strong> Most 2020 payouts have been processed, however
                            if your USD balance pre-2021 hasn't been sent to your PayPal account
                            already, please contact Support and we will process your payout
                            immediately.</b-alert
                        >
                    </template>

                    <div class="card card-custom gutter-b">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="card-label">Payouts</h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <!--begin::Table-->
                            <div class="table-responsive">
                                <table
                                    class="table table-head-custom table-head-bg table-vertical-center"
                                >
                                    <thead>
                                        <tr class="text-uppercase">
                                            <th style="min-width: 250px" class="pl-7">
                                                <span class="text-dark-75">Details</span>
                                            </th>
                                            <th style="min-width: 100px">Status</th>
                                            <th style="min-width: 100px">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="payout in affiliates.payouts"
                                            :key="payout.id"
                                            class="bg-hover-light"
                                        >
                                            <td class="pl-4">
                                                <div>
                                                    <a
                                                        class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                                                    >
                                                        {{ payout.paypal }}
                                                    </a>
                                                    <span
                                                        class="text-muted font-weight-bold d-block"
                                                    >
                                                        <span v-if="payout.status == 'completed'">
                                                            {{ payout.payoutdate }}
                                                        </span>
                                                        <span v-if="payout.status == 'requested'">
                                                            {{ payout.requestdate }}
                                                        </span>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <span
                                                    class="badge badge-success"
                                                    v-if="payout.status == 'completed'"
                                                >
                                                    Completed
                                                </span>
                                                <span
                                                    class="badge badge-warning"
                                                    v-if="payout.status == 'requested'"
                                                >
                                                    Requested
                                                </span>
                                            </td>
                                            <td>
                                                <template v-if="payout.NiceYear < 2021">
                                                    $ {{ roundTwoDecimals(payout.amount) }}
                                                </template>
                                                <template v-else>
                                                    {{ roundTwoDecimals(payout.amount) }} €
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <!-- GRAPH: All-time growth -->
                    <div class="card card-custom gutter-b">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="card-label">All-time Earnings</h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <!--begin::Chart-->
                            <apexchart
                                :options="allTimeChartOptions"
                                :series="allTimeChartSeries"
                                type="area"
                            ></apexchart>
                            <!--end::Chart-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End displayer -->
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>

<style scoped>
.blockquote {
    padding: 1.5rem;
    border-left: 4px solid #e2e5ec;
    background-color: #f7f8fa;
    font-size: inherit;
}
.blockquote-icon:hover {
    color: #1bc5bd;
    cursor: pointer;
}
</style>

<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
// Getters
import { mapGetters } from "vuex";
// Clipboard
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
// Mixins
import stringManagement from "@/mixins/stringManagement";
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "BlankPage",
    mixins: [stringManagement, axiosErrorManagement],
    components: {
        PagePreloader,
        CustomAlerts,
    },
    props: ["propUserId"],
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,

            // Displayers
            displayPage: false,

            // Error management
            errors: [],
            modalerrors: [],

            // Forms
            form: {
                email: "",
                amount: "",
            },

            // Modals
            modalIsLoading: false,

            // Data
            affiliatesAll: [],
            affiliates: [],
            currencyTab: "eur",

            // Charts
            allTimeChartOptions: {},
            allTimeChartSeries: [],
        };
    },

    methods: {
        // First method here
        getAffiliates() {
            // Set preloader
            // Reset errors
            this.errors = [];

            // Generate url
            if (typeof this.propUserId === "undefined") {
                var url = "affiliates";
            } else {
                var url = "affiliates?userid=" + this.propUserId;
            }

            // Perform post
            axios
                .get(url)
                .then((response) => {
                    // Set data
                    this.affiliatesAll = response.data;

                    // Set data
                    this.affiliates = this.affiliatesAll.metrics[this.currencyTab];

                    // Set the modal to the maximum amount
                    this.form.amount = this.affiliates.balance;

                    // NOTE - Generate chart
                    this.generateChart();
                    // // Set holders
                    // var allTimeChartData = [];
                    // var allTimeChartLabels = [];
                    // // Set
                    // this.affiliates.earnings_by_date.forEach((currentItem) => {
                    //     allTimeChartData.push(currentItem.earnings);
                    //     allTimeChartLabels.push(currentItem.date);
                    // });
                    // // Set data
                    // this.allTimeChartSeries = [
                    //     {
                    //         name: "Earnings",
                    //         data: allTimeChartData,
                    //     },
                    // ];
                    // this.allTimeChartOptions = {
                    //     chart: {
                    //         type: "area",
                    //         height: "auto",
                    //         zoom: {
                    //             enabled: false,
                    //         },
                    //     },
                    //     dataLabels: {
                    //         enabled: false,
                    //     },
                    //     stroke: {
                    //         curve: "straight",
                    //     },
                    //     labels: allTimeChartLabels,
                    //     xaxis: {
                    //         type: "datetime",
                    //     },
                    //     colors: ["#1bc5bd"],
                    //     yaxis: {
                    //         opposite: true,
                    //         labels: {
                    //             formatter: (value) => {
                    //                 return "$ " + this.roundTwoDecimals(value);
                    //             },
                    //         },
                    //     },
                    //     legend: {
                    //         horizontalAlign: "left",
                    //     },
                    // };

                    // Set displayer
                    this.displayPage = true;
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close preloader
                    this.pageIsLoaded = true;
                });
        },

        generateChart() {
            // Set holders
            var allTimeChartData = [];
            var allTimeChartLabels = [];
            // Set
            this.affiliates.earnings_by_date.forEach((currentItem) => {
                allTimeChartData.push(currentItem.earnings);
                allTimeChartLabels.push(currentItem.date);
            });
            // Set data
            this.allTimeChartSeries = [
                {
                    name: "Earnings",
                    data: allTimeChartData,
                },
            ];
            this.allTimeChartOptions = {
                chart: {
                    type: "area",
                    height: "auto",
                    zoom: {
                        enabled: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "straight",
                },
                labels: allTimeChartLabels,
                xaxis: {
                    type: "datetime",
                },
                colors: ["#1bc5bd"],
                yaxis: {
                    opposite: true,
                    labels: {
                        formatter: (value) => {
                            if (this.currencyTab == "eur") {
                                return this.roundTwoDecimals(value) + " €";
                            }
                            return "$ " + this.roundTwoDecimals(value);
                        },
                    },
                },
                legend: {
                    horizontalAlign: "left",
                },
            };
        },

        switchCurrency(currency) {
            this.currencyTab = currency;
            this.affiliates = this.affiliatesAll.metrics[currency];
            this.generateChart();
        },

        initCopy() {
            var clipboard = new ClipboardJS(".copy-link", {
                target: function (trigger) {
                    return trigger.nextElementSibling;
                },
            });

            clipboard.on("success", function (e) {
                // Set target
                var target = e.trigger.children[0].classList;
                // Switch class
                target.remove("fa-copy");
                target.add("fa-check");
                // Remove class after 2 seconds
                setTimeout(function () {
                    target.remove("fa-check");
                    target.add("fa-copy");
                }, 2000);
            });
        },

        openPayoutModal() {
            // Reset errors
            this.modalerrors = [];
            // Open modal
            this.$refs["payout-modal"].show();
        },

        requestPayout() {
            // Reset errors
            this.modalerrors = [];

            // Set loader
            this.modalIsLoading = true;

            // Post
            axios
                .post("affiliates/new", {
                    email: this.form.email,
                    amount: this.form.amount,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Close modal
                        this.$refs["payout-modal"].hide();

                        // Add success message
                        if (data.messages.length > 0) {
                            data.messages.forEach((currentItem) => {
                                this.errors.push({
                                    type: currentItem.type,
                                    message: currentItem.message,
                                });
                            });
                        }

                        // Add date to existing payouts
                        this.affiliates.payouts.unshift(data.data);
                    }

                    // Check for errors
                    if (data.messages.length > 0) {
                        data.messages.forEach((currentItem) => {
                            this.modalerrors.push({
                                type: currentItem.type,
                                message: currentItem.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.modalerrors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Unset loaders
                    this.modalIsLoading = false;
                });
        },
    },

    mounted() {
        // Get affiliates
        this.getAffiliates();

        // Set email to default
        this.form.email = this.currentUser.email;

        // Init copy
        this.initCopy();

        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Affiliates & Earnings", route: "affiliates" },
        ]);
    },

    computed: {
        ...mapGetters({ currentUser: "auth/currentUser" }),
    },
};
</script>
